import { FormFieldResponseDTO } from '@/api/base/DTOs';
import { IFormBase, IFormTextArea } from '@/forms/typings';
import { TextAreaFormFieldBuilder } from '@/forms/builders';
import { adaptFormFieldResponseToValue } from '../utilities/formFieldResponseToValue.adapter';
import { formApiAdapterRegistry } from '../registry/form-api-adapter.registry';

/**
 * Adapts a FormFieldResponseDTO to a TextAreaFormField
 * Handles multiline text input fields
 */
export const adaptFormFieldResponseToTextAreaFormField = (
  formFieldResponse: FormFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): IFormTextArea => {
  let textAreaFormField = new TextAreaFormFieldBuilder()
    .fieldId(formFieldResponse.fieldID)
    .name(formFieldResponse.fieldID)
    .label(formFieldResponse.label ?? formFieldResponse.name)
    .readonly(formFieldResponse.readonly || !formFieldResponse.isEditable)
    .value(adaptFormFieldResponseToValue(formFieldResponse))
    .hasAnyValue(formFieldResponse.hasAnyValue)
    .notApplicable(formFieldResponse.notApplicable)
    .showNotApplicable(formFieldResponse.showNotApplicable)
    .size(formFieldResponse.itemSize);

  if (formFieldResponse.hint) {
    textAreaFormField = textAreaFormField.hint(formFieldResponse.hint);
  }

  if (formFieldResponse.hintImageUrl) {
    textAreaFormField = textAreaFormField.hintImageUrl(
      formFieldResponse.hintImageUrl,
    );
  }

  if (formFieldResponse.helperText) {
    textAreaFormField = textAreaFormField.helperText(
      formFieldResponse.helperText,
    );
  }

  if (formFieldResponse.placeholder) {
    textAreaFormField = textAreaFormField.placeholder(
      formFieldResponse.placeholder,
    );
  }

  const textAreaFieldValidations =
    formApiAdapterRegistry.adaptGeneric(
      formFieldResponse.restriction,
    ) as IFormTextArea['validations'];

  if (textAreaFieldValidations) {
    textAreaFormField = textAreaFormField.validations(textAreaFieldValidations);
  }

  return textAreaFormField.parentFieldId(parentFieldId).build();
};
